import { Editor, Element, Transforms } from 'slate';
import { get, merge, set } from 'lodash';
import { useSlate } from 'slate-react';

const LIST_TYPES = ['numbered-list', 'bulleted-list'];

// TODO: set new attribute with merging previous attributes
const useSelectedBlock = () => {
    const editor = useSlate();

    const getProperty = (path = 'type') => {
        const { selection } = editor;
        if (!selection) return;

        const [[match]] = Array.from(
            Editor.nodes(editor, {
                at: Editor.unhangRange(editor, selection),
                match: n =>
                    !Editor.isEditor(n) &&
                    Element.isElement(n) &&
                    (path === 'type' ? n.type !== 'list-item' : true),
                ignoreNonSelectable: true,
                mode: 'lowest',
            }),
        );

        const maches = Array.from(
            Editor.nodes(editor, {
                at: Editor.unhangRange(editor, selection),
                match: n =>
                    !Editor.isEditor(n) &&
                    Element.isElement(n) &&
                    get(n, path) === get(match, path),
                // path === 'type'
                //     ? n.type === match.type
                //     : true,
                ignoreNonSelectable: true,
                universal: true,
            }),
        );

        return maches.length && get(match, path);
    };

    const setProperty = (path, value) => {
        const isList = LIST_TYPES.includes(value);

        Transforms.unwrapNodes(editor, {
            match: n =>
                !Editor.isEditor(n) &&
                Element.isElement(n) &&
                path === 'type' &&
                LIST_TYPES.includes(n.type),
            split: true,
        });

        let newProperties;
        if (path === 'type') {
            newProperties = {
                type: isList ? 'list-item' : value || 'paragraph',
            };
            Transforms.setNodes(editor, newProperties);
        } else {
            newProperties = set({}, path, value);
            Transforms.setNodes(editor, newProperties, {
                merge: (n, p) => merge({}, n, p),
            });
        }

        if (isList && path === 'type')
            Transforms.wrapNodes(editor, { type: value, children: [] });
    };

    const setType = type => setProperty('type', type);
    const type = getProperty();

    return { type, getProperty, setType, setProperty };
};

export default useSelectedBlock;
